export const GUEST_PROFILE_KEY = 'guestProfile';
